var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-polls-container"},[_c('div',[_vm._v(_vm._s(_vm.$t('POLLS.NO_ACTIVE_POLLS')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }